import React, { useEffect, useState } from "react";
import { BsEyeSlash } from "react-icons/bs";
import { GoPencil, GoPlus } from "react-icons/go";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoChevronDownSharp } from "react-icons/io5";
import apiRequests from "../../Component/axios/config/config";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import Loading from "../../Component/Loading/Loading";
import { Pencil, Camera } from "lucide-react";
import toast from "react-hot-toast";
import MapLocationPicker from "../../Component/MapLocationPicker/MapLocationPicker";
export default function Shop() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [profile, setProfile] = useState({
    storeName: "",
    bio: "",
    profileImage: "",
    header: "",
    lat: null,
    long: null,
  });

  const [profilePreview, setProfilePreview] = useState("");
  const [headerPreview, setHeaderPreview] = useState("");
  const [uploadingImage, setUploadingImage] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const profileRes = await apiRequests.get("/seller/v1/get-my-profile");
        if (profileRes.data.success) {
          const data = profileRes.data.data;
          setProfile({
            storeName: data.currentStoreName || "",
            bio: data.currentbio || "",
            profileImage: data.profileImage?._id || "",
            header: data.header?._id || "",
            lat: data.lat || null,
            long: data.long || null,
          });
          setProfilePreview(
            data.profileImage?.path
              ? `${process.env.REACT_APP_API_URL_image}${data.profileImage.path}`
              : "",
          );

          setHeaderPreview(
            data.header?.path
              ? `${process.env.REACT_APP_API_URL_image}${data.header.path}`
              : "",
          );
        }

        const categoryRes = await apiRequests.get("/category/get-all-user", {
          params: { limit: 20, page: 1 },
        });
        if (categoryRes.data.success) {
          setAvailableCategories(categoryRes.data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  function EditeProfile() {
    setLoadingEdit(true);

    const payload = {
      bio: profile.bio,
      storeName: profile.storeName,
      header: profile.header,
      profileImage: profile.profileImage,
      lat: profile.lat,
      long: profile.long,
    };

    apiRequests
      .post(`/seller/v1/request-store-profile-change`, payload)
      .then((res) => {
        toast.success(
          "Your request has been submitted successfully. Changes will be applied after admin approval.",
        );
      })
      .catch((err) => {
        console.error("Edit profile error:", err);
        toast.error("Failed to update profile. Server error.");
      })
      .finally(() => setLoadingEdit(false));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const uploadImage = async (file, type) => {
    setUploadingImage(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await apiRequests.post("/file/v1/upload-seller", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        setProfile((prev) => ({
          ...prev,
          [type]: res.data.message._id,
        }));

        toast.success("Image uploaded successfully");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to upload image");
    } finally {
      setUploadingImage(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-gray-500 font-medium">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center p-10 sm:p-4 text-[#5c4a40]">
      <div className="w-full max-w-7xl flex flex-col gap-12 sm:gap-6">
        <section className="relative mb-10 sm:mb-16">
          {/* Header Image */}
          <div className="relative h-72 sm:h-48 rounded-3xl overflow-hidden bg-[#efe5df]">
            {headerPreview ? (
              <img
                src={headerPreview}
                alt="Header"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                No Header Image
              </div>
            )}

            <label className="absolute bottom-4 right-4 bg-white p-3 rounded-full shadow cursor-pointer">
              <Camera className="w-5 h-5" />

              <input
                hidden
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;

                  setHeaderPreview(URL.createObjectURL(file));
                  uploadImage(file, "header");
                }}
              />
            </label>
          </div>

          {/* Profile Image */}
          <div className="absolute -bottom-16 left-10 sm:left-1/2 sm:-translate-x-1/2">
            <div className="relative">
              {profilePreview ? (
                <img
                  src={profilePreview}
                  alt="Profile"
                  className="w-32 h-32 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white"
                />
              ) : (
                <div className="w-32 h-32 sm:w-24 sm:h-24 rounded-full bg-[#efe5df] border-4 border-white flex items-center justify-center">
                  Profile
                </div>
              )}

              <label className="absolute bottom-0 right-0 bg-white rounded-full p-2 shadow cursor-pointer">
                <Pencil className="w-4 h-4" />

                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    setProfilePreview(URL.createObjectURL(file));
                    uploadImage(file, "profileImage");
                  }}
                />
              </label>
            </div>
          </div>

          <div className="h-20 sm:h-14" />
        </section>
        <section className="grid grid-cols-3 gap-x-7 gap-y-8 w-full sm:grid-cols-1 sm:gap-x-0 sm:gap-y-6">
          <div className="flex flex-col gap-2">
            <label
              htmlFor="Name"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Shop name:
            </label>
            <input
              type="text"
              name="storeName"
              disabled={!isEditing}
              value={profile.storeName}
              onChange={handleChange}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label
              htmlFor="bio"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Bio:
            </label>
            <input
              type="text"
              name="bio"
              disabled={!isEditing}
              value={profile.bio}
              onChange={handleChange}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />
          </div>
          <div className="flex flex-col gap-2 col-span-2 sm:col-span-1">
            <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
              Location
            </label>
            <MapLocationPicker
              latitude={profile.lat}
              longitude={profile.long}
              onChange={(lat, long) =>
                setProfile((prev) => ({ ...prev, lat, long }))
              }
              readOnly={!isEditing}
              height={200}
            />
          </div>
        </section>

        {/* <section className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <span className="font-medium text-xl opacity-80 mr-2 text-inputColor-labelColor">
            Categories:
          </span>

          <div className="flex flex-wrap gap-3 items-center">
            {profile.category.length > 0 ? (
              profile.category.map((catId) => {
                const cat = availableCategories.find((c) => c._id === catId);

                return (
                  <div
                    key={catId}
                    className="bg-[#efe5df] px-4 py-2 rounded-xl flex items-center gap-2"
                  >
                    <span>{cat?.name}</span>

                    <button
                      type="button"
                      onClick={() => {
                        setProfile((prev) => ({
                          ...prev,
                          category: prev.category.filter((id) => id !== catId),
                        }));
                      }}
                      className="text-xl opacity-60 hover:text-red-500"
                    >
                      <IoIosCloseCircleOutline />
                    </button>
                  </div>
                );
              })
            ) : (
              <span className="text-sm opacity-50">No categories</span>
            )}

            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="border border-[#5c4a40] opacity-80 px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-gray-50 bg-white"
              >
                <GoPlus className="text-xl" />
                <span>Add category</span>
              </button>

              {showDropdown && (
                <div className="absolute top-full left-0 mt-3 w-56 max-h-60 overflow-y-auto bg-white border border-[#efe5df] shadow-xl rounded-xl p-3 z-10 flex flex-col gap-2">
                  <input
                    placeholder="search categories"
                    className="bg-[#efe5df] rounded px-3 py-1 text-sm outline-none placeholder-[#5c4a40]/50"
                  />
                  <div className="flex flex-col text-sm opacity-80">
                    {availableCategories.map((c) => {
                      const isSelected = profile.category.includes(c._id);

                      return (
                        <span
                          key={c._id}
                          onClick={() => {
                            setProfile((prev) => {
                              if (prev.category.includes(c._id)) return prev;

                              return {
                                ...prev,
                                category: [...prev.category, c._id],
                              };
                            });
                          }}
                          className={`p-2 rounded cursor-pointer
        ${isSelected ? "bg-[#efe5df] opacity-50" : "hover:bg-[#efe5df]"}`}
                        >
                          {c.name}
                        </span>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section> */}
        <div className="flex justify-between items-center mb-8 sm:flex-col sm:items-stretch">
          <button
            onClick={() => {
              if (isEditing) {
                EditeProfile();
                setIsEditing(false);
              } else {
                setIsEditing(true);
              }
            }}
            className="bg-[#051F33] flex items-center justify-center gap-2 text-white px-5 py-2 rounded-2xl font-medium hover:bg-[#082a45] transition shadow-sm"
          >
            {loadingEdit ? (
              <Loading textColor={"white-0"} />
            ) : (
              <>
                <Pencil className="w-4 h-4" />
                {isEditing ? "Confirm Edit" : "Edit Profile"}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
